import { gtag, install } from 'ga-gtag';

import log, { logError } from '~/common/utils/log';
import type { User } from '~/services/users/types';
import { isBrowserFn } from '~/utils/browser';

// Conversion GTAG ID and stream ID (for conversion tracking in adwords, if used)
const GA4_GTAG_ID = process.env.NEXT_PUBLIC_GA4_GTAG_ID;

const initGtag = () => {
  if (!process.env.NEXT_PUBLIC_GA4_GTAG_ID) {
    log('Google tracking - No GTAG ID found');
    return;
  }

  // Initialise GTAG
  install(GA4_GTAG_ID, { send_page_view: true });

  // Google Consent Mode (via OSANO)
  gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'granted',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    personalization_storage: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 500,
  });
  gtag('set', 'ads_data_redaction', true);

  log('Google tracking - Initialised GTAG:', GA4_GTAG_ID);
};

const isGtagInitialised = () => isBrowserFn() && window.google_tag_manager;

const setGAuser = (user: Partial<User>) => {
  gtag('config', GA4_GTAG_ID, {
    email: user.email,
    user_id: user.id,
    user_name: user.username,
  });
};


const reportGAevent = (eventName: string, properties: Record<string, unknown> = {}) => {
  gtag('event', eventName, {
    ...properties,
  });
};

export default initGtag;
export { isGtagInitialised, setGAuser, reportGAevent };
